import api from '../../helper/api';

export default {
    settings: {
        persist: {
            storageKeyPathMapping: {
                notifications: [ 'stack' ]
            }
        },
        persistDistinct: {
            stack: {
                storage: 'db',
                storageKey: 'notifications'
            }
        }
    },

    module: {
        namespaced: true,

        state: {
            stack: [],
        },

        mutations: {
            setLoaded(state, notifications) {
                state.stack = notifications;
            },
            removeFromStack(state, id) {
                const removeIndex = state.stack.findIndex(p => p.id == id);

                if(removeIndex != -1) {
                    state.stack.splice(removeIndex, 1);
                }
            },
            clearStack(state) {
                state.stack = [];
            },
            setRead(state) {
                for(let i = 0; i < state.stack.length; i++) {
                    state.stack[i].read = true;
                }
            }
        },

        actions: {
            async load({ rootState, commit }) {
                return new Promise((resolve, reject) => {
                    if(!rootState.offline) {
                        api.get('notifications').run().then(response => {
                            commit('setLoaded', response.valueOf());
                            resolve(response.valueOf());
                        }, err => {
                            reject(err);
                        });
                    }
                });
            },
            read({ commit, dispatch }) {
                const updateTask = api.post('notifications/read').name('notificationsRead').run();

                dispatch('tasks/runUnique', updateTask, { root: true });

                commit('setRead');
            },
            delete({ commit, dispatch }, id) {
                const removeTask = api.delete(`notifications/${id}`).run();

                dispatch('tasks/run', removeTask, { root: true });

                commit('removeFromStack', id);
            },
            clear({ commit, dispatch }) {
                const clearTask = api.delete(`notifications/until/${Math.floor(Date.now() / 1000)}`).run();

                dispatch('tasks/run', clearTask, { root: true });

                commit('clearStack');
            }
        }
    }
}